module.exports = __webpack_public_path__ + "img/MTW.99def9fb.svg";